import React from 'react';
import PropTypes from 'prop-types';
import * as i18n from 'i18next';

MeasurementHeader.propTypes = {
  quantityText: PropTypes.string,
  beforeText: PropTypes.string,
};

function MeasurementHeader({ quantityText, beforeText }) {
  return (
    <>
      <p className="mb-0">{i18n.t('trackingScreen:header.title')}</p>
      <p className="mb-0">
        <strong className="">{quantityText}</strong>
      </p>
      <span>{beforeText}</span>
    </>
  );
}

export default MeasurementHeader;
